import { render, staticRenderFns } from "./barometer.vue?vue&type=template&id=08f6bd84"
import script from "./barometer.vue?vue&type=script&lang=js"
export * from "./barometer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports